<template>
  <v-tabs
    background-color="transparent"
    color="primary"
    v-model="majorityFilterStatus"
    :show-arrows="$vuetify.breakpoint.mdAndDown">
    <v-tab
      key="ALL"
      href="#ALL">
      Todos
    </v-tab>

    <v-tab
      key="EXCLUSION"
      href="#EXCLUSION">
      Exclusões solicitadas
    </v-tab>

    <v-tab
      key="EXTENSION"
      href="#EXTENSION">
      Permanências solicitadas
    </v-tab>

    <v-tab
      key="PENDING"
      href="#PENDING">
      Sem solicitação
    </v-tab>
  </v-tabs>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	name: "MajoritySubfilter",

  methods: {
    ...mapActions({
      setMajorityFilter: 'majority/setMajorityFilter',
    }),
  },

  computed: {
    ...mapGetters({
      majorityFilter: 'majority/majorityFilter',
      pageMounted: 'majority/pageMounted'
    }),

    majorityFilterStatus: {
      get() {
        return this.majorityFilter.majorityStatus
      },

      set(status) {
        if (!this.pageMounted) return;
        const majorityStatus = status === 'ALL' ? null : status;
        this.setMajorityFilter({majorityStatus: majorityStatus});
      }
    }
  },
}
</script>
